import ko from "knockout";
import metaCache from "flow/utils/metaCache";
import { cleanHtml } from "flow/utils/cleanHtml";

class TextMetaViewModel {
    html: string;

    constructor(componentInfo: KnockoutComponentTypes.ComponentInfo) {
        this.html = undefined;
        if (componentInfo.templateNodes.length > 0) {
            const node = componentInfo.templateNodes[0];
            if (node.nodeType === 3) {
                // text
                this.html = cleanHtml(metaCache.translate((node as Text).data));
            }
        }
    }
}

ko.components.register("ko-meta-safe-html", {
    viewModel: {
        createViewModel: (_params: any, componentInfo: KnockoutComponentTypes.ComponentInfo) => {
            return new TextMetaViewModel(componentInfo);
        }
    },
    template: "{{{html}}}",
    synchronous: true
});
